import { connect } from 'react-redux';
import ProductListingResultsMessage from '../ProductListingResultsMessage/ProductListingResultsMessage';
import { getActiveListingPage } from '../../reduck/selectors';


function mapStateToProps(state) {
  return {
    showingResultsLabel: getActiveListingPage(state).showingResultsLabel,
    productsRequestErrorMessage: state.listingPage.commonData.xhrStatus.productsRequestErrorMessage,
    deviceType: state.listingPage.browser ? state.listingPage.browser.device.deviceType : undefined,
    categoryProductCount: getActiveListingPage(state).categoryTotalProductCount,
    noResults: getActiveListingPage(state).productList.length === 0
  };
}

export default connect(mapStateToProps)(ProductListingResultsMessage);
